import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import style from './pendingLeadsCard.module.scss';

function LeadsAccountIndicator({ count }) {
  return (
    <Box className={style.leadsAccountIndicator}>
      <Icon icon="icon-contactos" />
      <Text>{count}</Text>
    </Box>
  );
}

export default LeadsAccountIndicator;
